import CustomCommonTooltip from "@/shared/components/ui/Upload/ToolTip/CustomCommonTooltip";
import { formatStepDate } from "@/shared/utils/helperFunctions";
import { activities } from "@/shared/utils/utils";

const resolveValue = (item, activity) =>
  item?.[activity.key] || (activity.altKey && item?.[activity.altKey]);

const CONNECTION_ACTIVITY_BY_ACTION = {
  "requests sent": {
    key: "connect_sent_at",
    label: "Connection Sent",
    color: "bg-blue-50 text-secondary border-blue-200",
  },
  "requests accepted": {
    key: "connected_at",
    label: "Connection Accepted",
    color: "bg-green-50 text-green-700 border-green-200",
  },
  "requests failed": {
    key: "failed_at",
    label: "Connection Failed",
    color: "bg-red-50 text-red-700 border-red-200",
  },
};

const EngagementTabs = ({ item, action }) => {
  const connectionActivity =
    CONNECTION_ACTIVITY_BY_ACTION[String(action || "").trim().toLowerCase()];

  if (connectionActivity) {
    const timestamp = item?.[connectionActivity.key];
    const isFailedConnection =
      connectionActivity.key === "failed_at" &&
      String(item?.status || "").trim().toUpperCase() === "FAILED";

    if (!timestamp && !isFailedConnection) {
      return <span className="text-xs text-gray-300">No Activity</span>;
    }

    const tooltipContent =
      connectionActivity.key === "failed_at"
        ? `${item?.failure_reason || "Connection request failed"}${
            timestamp ? ` (${formatStepDate(timestamp)})` : ""
          }`
        : formatStepDate(timestamp);

    return (
      <CustomCommonTooltip
        content={tooltipContent}
        className="text-xs text-gray-600"
      >
        <div
          className={`px-2 py-1 text-xs rounded-full border cursor-pointer transition-all duration-150 hover:scale-105 ${connectionActivity.color}`}
        >
          {connectionActivity.label}
        </div>
      </CustomCommonTooltip>
    );
  }

  const completedActivities = activities?.filter(
    (activity) => resolveValue(item, activity),
  );

  if (!completedActivities.length) {
    return <span className="text-xs text-gray-300">No Activity</span>;
  }

  return (
    <div className="flex flex-wrap gap-2">
      {completedActivities.map((activity) => (
        <CustomCommonTooltip
          key={activity.key}
          content={formatStepDate(resolveValue(item, activity))}
          className="text-xs text-gray-600"
        >
          <div
            className={`px-2 py-1 text-xs rounded-full border cursor-pointer transition-all duration-150 hover:scale-105 ${activity.color}`}
          >
            {activity.label}
          </div>
        </CustomCommonTooltip>
      ))}
    </div>
  );
};

export default EngagementTabs;
